import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Timeline from './Timeline';
import './Header.css';

function Header({ 
  showBackButton = false, 
  onBack = null,
  showLogIcon = true
}) {
  const navigate = useNavigate();
  const [isTimelineOpen, setIsTimelineOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentDay, setCurrentDay] = useState(() => {
    // Get current day from session storage or default to 1
    return parseInt(sessionStorage.getItem('currentDay')) || 1;
  });
  const dropdownRef = useRef(null);
  
  // Handle clicks outside dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const handleLogClick = () => {
    setIsTimelineOpen(true);
  };
  
  const handleDayChange = (day) => {
    setCurrentDay(day);
    sessionStorage.setItem('currentDay', day.toString());
    setIsDropdownOpen(false);
  };
  
  const handleTimelineClose = () => {
    setIsTimelineOpen(false);
  };
  
  return (
    <div className="app-header">
      <div className="header-left">
        <div className="header-dropdown" ref={dropdownRef}>
          <button 
            className={`dropdown-button ${isDropdownOpen ? 'open' : ''}`}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            DAY {currentDay}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </button>
          
          <div className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}>
            {[1, 2, 3, 4, 5, 6, 7].map((day) => (
              <div 
                key={day} 
                className={`dropdown-item ${currentDay === day ? 'active' : ''}`}
                onClick={() => handleDayChange(day)}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
                </svg>
                Day {day}
              </div>
            ))}
          </div>
        </div>
        
        {showBackButton && onBack && (
          <button className="back-button-header" onClick={onBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
          </button>
        )}
      </div>
      
      <div className="header-center">
        {/* Space for future use */}
      </div>
      
      <div className="header-right">
        <button className="book-icon-button" title="Return to Cover" onClick={() => navigate('/home')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 2.45 0 4.55.4 5.5 1.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
          </svg>
        </button>
        {showLogIcon && (
          <button className="log-icon-button" title="Investigation Log" onClick={handleLogClick}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
            </svg>
          </button>
        )}
      </div>
      
      <Timeline isOpen={isTimelineOpen} onClose={handleTimelineClose} />
    </div>
  );
}

export default Header;
